import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, error } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error('Por favor, completa todos los campos correctamente.', {
        theme: 'colored',
      });
      return;
    }

    const success = await login(email, password);
    if (success) {
      navigate('/roles');
    } else {
      toast.error(error || 'Correo o contraseña incorrectos.', {
        theme: 'colored',
      });
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div
        className="card shadow-sm border-0 rounded-4 p-4"
        style={{ maxWidth: '400px', width: '100%' }}
      >
        <h3
          className="text-center fw-bold mb-4 text-primary"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Iniciar sesión
        </h3>

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Correo electrónico</label>
            <input
              type="email"
              className="form-control form-control-lg rounded-3"
              placeholder="tuemail@ejemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Contraseña</label>
            <input
              type="password"
              className="form-control form-control-lg rounded-3"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg w-100 rounded-pill shadow-sm mt-2"
          >
            Acceder
          </button>
        </form>

        <div className="text-center mt-3">
          <a
            href="/forgot-password"
            className="text-decoration-none text-muted small"
          >
            .
          </a>
        </div>

        <div className="text-center mt-2">
          <span className="small">¿Nó tienes cuenta? </span>
          <Link
            to="/crear-cuenta"
            className="text-primary fw-semibold text-decoration-none"
          >
            Crear cuenta
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
